import React, { useState } from "react";
//import "./styles.css";
import { Form } from "react-bootstrap";
import "./wix-template.css";
//import DataTable from "react-data-table-component";
import { Pdf } from "../../../../assets/images";
import axios from "../../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../../utils/adminConfig";
const TransactionDetails = () => {
  const [file, setFile] = useState("");
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);

  const addCalendar = async (e) => {
    e.preventDefault();

    setLoading(true);
    let data = new FormData();

    if (file) {
      data.append("image", file);
      data.append("title", title);
      // data.append("isTripValet", isTripValet);
      // data.append("isTripValetIncentive", isTripValetIncentive);

      await axios
        .post(`/add-resource`, data, adminConfig())
        .then((res) => {
          if (res.data.status === true) {
            message.success("added Resource success");
          } else {
            message.error("failed adding Resource");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      setLoading(false);
    } else {
      message.error("file not found");
      setLoading(false);
    }
  };
  return (
    // <div>
    //     <HeaderPart />
    //     <div className='main_cont'>
    //         <LeftpanelAdmin />
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added resources_p">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Enter Title</Form.Label>
                  <Form.Control
                    type="text"
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                    placeholder="Enter title"
                    className="text_link"
                  />
                </Form.Group>
                <div className="upload_pdf">
                  <h3>Upload Pdf</h3>
                  <div className="upload_btn_wrapper">
                    <button className="btn_bulk">
                      <span className="cert_bulkks">
                        <img src={Pdf} alt="" />
                      </span>
                      {file ? (
                        file.name
                      ) : (
                        <>
                          Upload Image
                          <input
                            type="file"
                            accept=".pdf"
                            name="myfile"
                            onChange={(e) => {
                              // console.log(e.target.files[0]);
                              setFile(e.target.files[0]);
                            }}
                          />
                        </>
                      )}
                    </button>
                    {/* <input type="file" name="myfile" accept=".pdf" /> */}
                  </div>
                </div>

                <div className="sub_but">
                  <button
                    type="button"
                    onClick={addCalendar}
                    className="add_but submit_buttt mt-0"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
    /* </div>
            </div> */
  );
};

export default TransactionDetails;
